/* global CustomFunctions */
import { QueryClient, QueryObserver, QueryObserverOptions } from "@tanstack/react-query";
import { ENVIRONMENT } from "./config";
import { Environment } from "./types";

export const QUERY_CLIENT = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:
        ENVIRONMENT === Environment.Local || ENVIRONMENT === Environment.Development ? 1 * 60 * 1000 : 5 * 60 * 1000,
      refetchOnMount: true,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),
      retry: 3,
    },
  },
});

export function observerForCustomFunction<Data, QueryError = Error, QueryData = Data>(
  invocation: CustomFunctions.StreamingInvocation<Data | CustomFunctions.Error>,
  query: QueryObserverOptions<QueryData, QueryError, Data, QueryData, string[]>
): QueryObserver<QueryData, QueryError, Data, QueryData> {
  const observer = new QueryObserver(QUERY_CLIENT, query);
  observer.subscribe(({ status, data }) => {
    switch (status) {
      case "success":
        invocation.setResult(data);
        break;
      case "error":
        invocation.setResult(
          new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable, "An error occurred while fetching data.")
        );
        break;
      case "pending":
        invocation.setResult(
          new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable, "Pending result, no data available yet.")
        );
        break;
    }
  });
  invocation.onCanceled = () => observer.destroy();
  return observer;
}
